import React from 'react';
import { NAVIGATION_APPS_PROFILE_ITEM_NUDGE_ID } from '@atlassian/jira-onboarding-core/src/constants.tsx';
import { OnboardingNudgeErrorBoundary } from '@atlassian/jira-onboarding-quickstart-core/src/common/ui/onboarding-nudge-error-boundary/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { WrapperProps } from '../../common/types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const NavigationProfileNavItemWrapperNudgeLazy = lazyAfterPaint(
	() =>
		import(
			/* webpackChunkName: "async-software-onboarding-navigation-profile-nudge" */ './index'
		).then((exportedModule) => exportedModule.NavigationProfileNavItemWrapperNudge),
	{
		ssr: false,
	},
);

export const NavigationProfileNavItemWrapperNudgeAsync = ({ children }: WrapperProps) => (
	<OnboardingNudgeErrorBoundary
		id="asyncProfileNudge"
		fallback={children}
		attributes={{ NAVIGATION_APPS_PROFILE_ITEM_NUDGE_ID }}
	>
		<Placeholder name="navigation-profile-nav-item-wrapper-nudge-lazy" fallback={children}>
			<NavigationProfileNavItemWrapperNudgeLazy nudgeId={NAVIGATION_APPS_PROFILE_ITEM_NUDGE_ID}>
				{children}
			</NavigationProfileNavItemWrapperNudgeLazy>
		</Placeholder>
	</OnboardingNudgeErrorBoundary>
);

NavigationProfileNavItemWrapperNudgeAsync.displayName = 'NavigationProfileNavItemWrapperNudgeAsync';
